import * as yup from "yup";
import { paginatedSearchRequest, generatePaginationSchema, } from "../pagination";
import { colorSchema } from "./color_api";
import { userSchema } from "./user_api";
import { toggleableParamSchema } from "./params";
export var dealSchema = yup
    .object({
    id: yup.number().defined(),
    name: yup.string().defined(),
    isEnabled: yup.boolean().defined(),
    fullName: yup.string().defined().nullable(),
    color: colorSchema.defined().nullable(),
    teammates: yup.array(userSchema.defined()).defined(),
    remarks: yup.string().defined().nullable(),
    additional: yup.object(),
})
    .camelCase()
    .defined();
export var listDealRequestSchema = yup
    .object()
    .concat(paginatedSearchRequest)
    .concat(toggleableParamSchema);
export var listDealResponseSchema = generatePaginationSchema(dealSchema);
export var createDealRequestSchema = yup
    .object()
    .shape({
    name: yup.string().defined(),
    full_name: yup.string().defined().nullable(),
    remarks: yup.string().defined().nullable(),
    color_id: yup.number().defined().nullable(),
    teammates: yup.array(yup.number().defined()).defined(),
    additional: yup.object().defined().nullable(),
})
    .snakeCase()
    .defined();
export var editDealRequestSchema = yup
    .object()
    .shape({
    name: yup.string().defined(),
    full_name: yup.string().defined().nullable(),
    remarks: yup.string().defined().nullable(),
    color_id: yup.number().defined().nullable(),
    teammates: yup.array(yup.number().defined()).defined(),
    additional: yup.object().defined().nullable(),
})
    .snakeCase()
    .defined();
